import { PendingEverifyItem } from '../../../application/domain/entities/PendingEverifyItem';
import { PendingEverifyItemDto } from '../dto/PendingEverifyItemDto';

export const mapPendingEverifyItemDtoToEntity = (
  dto: PendingEverifyItemDto
): PendingEverifyItem => {
  return new PendingEverifyItem(
    dto.everifyCaseQueueId,
    dto.everifyCaseId,
    dto.everifyCaseNumber,
    dto.firstName,
    dto.lastName,
    dto.ssn,
    dto.locationName,
    dto.caseStatus,
    dto.caseStatusDisplay,
    dto.caseEligibilityStatement,
    dto.dhsReferralStatus,
    dto.ssaReferralStatus,
    dto.isUserActionRequired,
    dto.actionRequiredToResolveDuplicateCase,
    dto.duplicateCaseId,
    dto.pendingUserAction,
    dto.pendingSystemAction,
    dto.caseCreationStatus,
    dto.caseCreationError,
    dto.i9FormId,
    undefined,
    undefined,
    dto.awaitingDelayReason === true
  );
};
